<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiDutyQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="职责查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 90px;">职责名称：</div>
						<a-input v-model="query.dutyName" style="width: 100%;" placeholder="请输入职责名称" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 90px;">权限类型：</div>
						<a-select v-model="query.dutyType" style="width: 100%;">
							<a-select-option value="1">全部</a-select-option>
							<a-select-option value="2">菜单</a-select-option>
							<a-select-option value="3">权限</a-select-option>
						</a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiDutyQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>首级</a-breadcrumb-item>
					<a-breadcrumb-item href="" v-for="(item,index) in mainNavigation" :key="index"><i :class="item.icon"></i>{{item.dutyName}}</a-breadcrumb-item>
				</a-breadcrumb>
				<a-tooltip placement="bottomRight">
					<template slot="title">
					  <span>返回上一级</span>
					</template>
					<a-button type="link" @click="backMainNavigation"><i class="icon-sjp-fanhui"></i></a-button>
				</a-tooltip>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="dutyId"
				:loading="tableLoading" :pagination="false">
				<span slot="dutyName" slot-scope="dutyName">
					<a-button type="link" @click="edit(dutyName)" >{{dutyName.dutyName}}</a-button>
				</span>
				<span slot="icon" slot-scope="icon">
					<i :class="icon"></i>
				</span>
				<span slot="dutyType" slot-scope="dutyType">
					<span v-if="dutyType == 2">菜单</span>
					<span v-if="dutyType == 3">权限</span>
				</span>
				<span slot="dutyState" slot-scope="dutyState">
					<span v-if="dutyState == 2">禁用</span>
					<span v-if="dutyState == 3">启用</span>
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="addMainNavigation(tableAction)" >子职责</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<a-form-model-item label="职责名称" has-feedback prop="dutyName">
					<a-input v-model="addForm.dutyName" />
				</a-form-model-item>
				<a-form-model-item label="跳转链接" has-feedback prop="dutyUrl">
					<a-input v-model="addForm.dutyUrl" />
				</a-form-model-item>
				<a-form-model-item label="权限类型" has-feedback prop="dutyType">
					<a-select v-model="addForm.dutyType" >
						<a-select-option value="2">菜单</a-select-option>
						<a-select-option value="3">权限</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="dutySort">
					<a-input  v-model="addForm.dutySort" />
				</a-form-model-item>
				<a-form-model-item label="图标" has-feedback prop="icon">
					<a-input  v-model="addForm.icon" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<a-form-model-item label="职责名称" has-feedback prop="dutyName">
					<a-input v-model="editForm.dutyName" />
				</a-form-model-item>
				<a-form-model-item label="跳转链接" has-feedback prop="dutyUrl">
					<a-input v-model="editForm.dutyUrl" />
				</a-form-model-item>
				<a-form-model-item label="权限类型" has-feedback prop="dutyType">
					<a-select v-model="editForm.dutyType" >
						<a-select-option value="2">菜单</a-select-option>
						<a-select-option value="3">权限</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="排序" has-feedback prop="dutySort">
					<a-input  v-model="editForm.dutySort" />
				</a-form-model-item>
				<a-form-model-item label="图标" has-feedback prop="icon">
					<a-input  v-model="editForm.icon" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					parentId: 0,
					dutyName: '',
					dutyType: '1',
				},
				mainNavigation: [
					
				],
				tableData: [],
				tableColumns: [{
						title: '职责ID',
						dataIndex: 'dutyId',
						key: 'dutyId',
						align: 'center'
					},
					{
						title: '图标',
						dataIndex: 'icon',
						key: 'icon',
						align: 'center',
						scopedSlots: {
							customRender: 'icon'
						}
					},
					{
						title: '职责名称',
						// dataIndex: 'dutyName',
						key: 'dutyName',
						align: 'center',
						scopedSlots: {
							customRender: 'dutyName'
						}
					},
					{
						title: '跳转链接',
						dataIndex: 'dutyUrl',
						key: 'dutyUrl',
						align: 'center'
					},
					{
						title: '权限类型',
						dataIndex: 'dutyType',
						key: 'dutyType',
						align: 'center',
						scopedSlots: {
							customRender: 'dutyType'
						}
					},
					{
						title: '状态',
						dataIndex: 'dutyState',
						key: 'dutyState',
						align: 'center',
						scopedSlots: {
							customRender: 'dutyState'
						}
					},
					{
						title: '排序',
						dataIndex: 'dutySort',
						key: 'dutySort',
						align: 'center'
					},
					{
						title: '级别',
						dataIndex: 'dutyLevel',
						key: 'dutyLevel',
						align: 'center'
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					dutyName: '',
					dutyUrl: '',
					dutyType: '2',
					dutySort: 0,
					dutyLevel: 1,
					icon: ''
				},
				addRules: {
					dutyName: [{ required: true, message: '职责名称不能为空', trigger: 'blur' }],
					dutyType: [{ required: true, message: '请选择权限类型', trigger: 'blur' }],
					dutySort: [{ required: true, pattern: new RegExp(/^[0-9]\d*$/, "g"), message: '请填入纯数字', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					dutyName: '',
					dutyUrl: '',
					dutyType: '2',
					dutySort: 0,
					dutyLevel: 1,
					icon: ''
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//表格面包屑-开始
			addMainNavigation(item) {
				this.mainNavigation.push(item)
				this.query.parentId = item.dutyId
				this.query.page = 1
				this.apiDutyQueryList()
				
			},
			backMainNavigation() {
				this.mainNavigation.pop()
				let i = this.mainNavigation.length
				if (i == 0) {
					this.query.parentId = 0
				} else {
					i = i -1
					this.query.parentId = this.mainNavigation[i].dutyId
				}
				this.query.page = 1
				this.apiDutyQueryList()
				
			},
			//表格面包屑-结束
			async apiDutyQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDutyQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiDutyQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiDutyQueryList()
			},
			//添加弹窗事件-开始
			async apiDutyAdd() {
				this.addForm.parentId = this.query.parentId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDutyAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiDutyQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiDutyAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				this.editForm = item
				this.editForm.dutyType = this.editForm.dutyType + ''
				this.editVisible = true
			},
			async apiDutyEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDutyEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiDutyQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiDutyEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.dutyId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.dutyName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiDutyDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiDutyDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDutyDel, {dutyId: this.tableSelectedRows.dutyId, parentId: this.tableSelectedRows.parentId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiDutyQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.dutyId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiDutyQueryList()
		}
	};
</script>

<style scoped>
	

</style>
